import { render, staticRenderFns } from "./footerTitle.vue?vue&type=template&id=f10e2ef0&scoped=true&"
import script from "./footerTitle.vue?vue&type=script&lang=js&"
export * from "./footerTitle.vue?vue&type=script&lang=js&"
import style0 from "./footerTitle.vue?vue&type=style&index=0&id=f10e2ef0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f10e2ef0",
  null
  
)

export default component.exports